<template>
    <svg 
    :width="width"
    :height="height" 
    viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 18C9.72694 18 9.4587 17.9261 9.22222 17.7856L3.77778 14.5849C3.54154 14.4446 3.34532 14.2429 3.2088 13.9999C3.07229 13.7569 3.00028 13.4813 3 13.2007V6.79934C3.00028 6.51871 3.07229 6.24308 3.2088 6.00011C3.34532 5.75714 3.54154 5.55538 3.77778 5.41506L9.22222 2.2144C9.4587 2.07395 9.72694 2 10 2C10.2731 2 10.5413 2.07395 10.7778 2.2144L16.2222 5.41506C16.4585 5.55538 16.6547 5.75714 16.7912 6.00011C16.9277 6.24308 16.9997 6.51871 17 6.79934V13.2007C16.9997 13.4813 16.9277 13.7569 16.7912 13.9999C16.6547 14.2429 16.4585 14.4446 16.2222 14.5849L10.7778 17.7856C10.5413 17.9261 10.2731 18 10 18ZM10 18V10M4 6L10 9.5L16 6" 
        :stroke="iconColor"
        stroke-width="2" 
        stroke-linecap="round" 
        stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 24,
    },
    height: {
      type: [Number, String],
      default: 24,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>